/* eslint-disable */
import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Tooltip,
  Legend
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Tooltip, Legend);

const RecordToReportBarChart = ({labels = [],datasets = [],Heading = "",height = "200px",title = '', showDataLabels = true,showLegend = true}) => {

  const chartData = {
    labels,
    datasets: datasets.map((dataset) => ({
      ...dataset,
      borderRadius: 4,
      barPercentage: 0.8,      // Adjusts bar width within category
      categoryPercentage: 0.5, // Adjusts space between bars
      // barThickness: 30,
    })),

  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    layout: {
      padding: {
        top: 20,   // <-- adds space below legend
      },
    },
    plugins: {
      title: {
        display: !!title,
        text: title,
      },
      legend: {
        display: showLegend,
        position: 'bottom',
        labels: {
          font: {
            size: 10,   // <-- Change legend font size
            family: "Roboto"
          },
          boxWidth: 12,     // <-- size of color box
          boxHeight: 12,    // <-- height of color box
          padding: 15       // <-- spacing around each item
        }
      },
      tooltip: {
        enabled: true,
      },
      datalabels: {
      display: showDataLabels,   // This hides the datas on the bars
      anchor: "end",
      align: "end",
      color: "#000",  // Change label color
      font: {
          size: 9,
          weight: "bold",
          family: "Roboto",
        },
      }
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
          font: {
            size: 9,     // X-axis font size
            family: "Roboto"
          }
        },
      },
    },
  };

  return (
    <div style={{ width: '100%', height: height }}>

      <div className='d-flex justify-content-center'> <h6>{Heading}</h6>
      </div>
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default RecordToReportBarChart;